import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { applyOpenGraphThumbnailSize, classNames } from '@shapeable/utils';
import { Page, Person } from '@shapeable/gesda-types';
import { EntityPublicationCard, EntityPublicationCardDefaultProps, EntityPublicationCardProps } from './entity-publication-card';
const cls = classNames('page-publication-card');

// -------- Types -------->

// -------- Props -------->

export type PagePublicationCardProps = Omit<EntityPublicationCardProps, 'entity'> & { 
  entity?: Page;
};

export const PagePublicationCardDefaultProps: Omit<PagePublicationCardProps, 'entity'> = {
  ...EntityPublicationCardDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    ${theme.FILL('dark')};
  `,
});

const ContributorsStyles = css`
  display: block;
  font-weight: 300;
  font-size: ${14/14}em;
  line-height: 1.30em;
  color: ${theme.COLOR('text-subtle')};
  padding-top: ${theme.UNIT(5)};
`;
// -------- Components -------->

const My = {
  Container: styled(EntityPublicationCard)<ContainerProps>`${ContainerStyles}`,
    Contributors: styled.span`${ContributorsStyles}`,
};

export const PagePublicationCard: Shapeable.FC<PagePublicationCardProps> = (props) => {
  const { className, entity, ...cardProps } = props;

  const { people = [] } = entity;

  const transformedEntity: Person = applyOpenGraphThumbnailSize('bubbleLarge')(props.entity);

  const visiblePeople = people.slice(0, 6);
  const personNames = visiblePeople.map((person) => person?.name || '').filter(Boolean).join(', ');
  const remainingPeopleCount = people.length - visiblePeople.length;
  const contributorsLabel = personNames
    ? remainingPeopleCount > 0
      ? `${personNames}, +${remainingPeopleCount} (Contributors)`
      : `${personNames} (Contributors)`
    : '';

  return (
    <My.Container 
      {...cardProps} 
      entity={transformedEntity}
      foot={
        contributorsLabel && (
          <My.Contributors>{contributorsLabel}</My.Contributors>
        )
      }
      />
  )
};

PagePublicationCard.defaultProps = PagePublicationCardDefaultProps;
PagePublicationCard.cls = cls;